import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentPageComponent } from './content-page.component';
import { ContentComponent } from '../../shared/content/content/content.component';


@NgModule({
  declarations: [
    ContentPageComponent,
  ],
  imports: [
    CommonModule,

    ContentComponent,
  ]
})
export class ContentPageModule { }
